module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/26.dfa4b783.png";